import { useCallback } from 'react';
import { Platform } from 'react-native';

import { type OrderingContext } from '@order/features/ordering';

import { useGlobalAppState } from '../../../../context/GlobalAppState';

export const usePostOrderPurchaseModal = () => {
  const { postPurchaseModalMachineRef } = useGlobalAppState();

  const handlePostOrderPurchaseModal = useCallback(
    ({ context }: { context: OrderingContext }) => {
      const { orderId = '', hasEarnedLoyaltyPoints } = context;

      if (orderId && hasEarnedLoyaltyPoints) {
        setTimeout(
          () => {
            // NOTE: We use a short delay on iOS because of a known issue during interactions between two modals.
            postPurchaseModalMachineRef.send({ type: 'show', orderId });
          },
          Platform.select({ ios: 750, default: 0 }),
        );
      }
    },
    [postPurchaseModalMachineRef],
  );

  // ─────────────────────────────────────────────────────────────────────

  return { handlePostOrderPurchaseModal };
};
